<template>
    <div class="custom-filter">
        <div class="custom-filter__inputs align-start">
            <div class="custom-filter__inputs--label">
                Date
                <div class="label currency-datepicker">
                    <div class="label__input-wrap">
                        <datepicker placeholder="De"
                                    format="DD/MM/YYYY"
                                    :monday-first="true"
                                    :full-month-name="true"
                                    wrapper-class="currency-datepicker__wrapper-low-margin mb-3"
                                    input-class="currency-datepicker__input"
                                    calendar-class="currency-datepicker__element"
                                    v-model="filters.start_date"
                                    :highlighted="filters.start_date ? '' : highlightedConfig">
                        </datepicker>
                        <datepicker placeholder="à"
                                    format="DD/MM/YYYY"
                                    :monday-first="true"
                                    :full-month-name="true"
                                    wrapper-class="currency-datepicker__wrapper-low-margin"
                                    input-class="currency-datepicker__input"
                                    calendar-class="currency-datepicker__element"
                                    v-model="filters.end_date"
                                    :highlighted="filters.end_date ? '' : highlightedConfig">
                        </datepicker>
                    </div>
                </div>
            </div>

            <label class="custom-filter__inputs--label">
                Montant
                <input class="custom-filter__inputs--field" v-model="filters.amount"
                       oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
            </label>

        </div>
        <div class="custom-filter__buttons">
            <button class="custom-filter__buttons--button" @click="emitFilters">Rechercher</button>
        </div>
    </div>
</template>

<script>
    import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker'

    export default {
        name: 'CommissionFilters',
        components: {Datepicker},
        data() {
            return {
                highlightedConfig: {
                    dates: [new Date()],
                }
            }
        },
        props: {
            filters: Object
        },
        methods: {
            emitFilters() {
                console.log("Emitting get-commissions with filters:", this.filters);
                // Emit the correct event name that the parent is listening for
                this.$emit('get-commissions', 1); // Pass page number
                // Also emit via eventBus for consistency
                this.$eventBus.$emit('get-commissions', 1);
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Representative/Commission/CommissionFilters.vue